import { IAppLoaderStorage, StorageKey } from '../types/utils/storage-types';
import { Product } from '../../../shared/infrastructure/types/common/common-types';

class AppStorage implements IAppLoaderStorage {
  shardUrl: Url | undefined;
  appServers: Url[] = [];

  get authToken(): AccessTokenBody | undefined {
    return window.authToken ? window.authToken : undefined;
  }

  get apiUrl(): Url | undefined {
    return this.shardUrl ? this.shardUrl : undefined;
  }

  get apiHost(): Host | undefined {
    return this.apiUrl ? (new URL(this.apiUrl).host as Host) : undefined;
  }

  get apiProtocol(): Protocol | undefined {
    return this.apiUrl ? (new URL(this.apiUrl).protocol as Protocol) : undefined;
  }

  get shardUrls(): Url[] | undefined {
    return this.appServers || [];
  }

  get product(): Product | undefined {
    return window.product ? window.product : undefined;
  }

  get supremeUrl(): Url | undefined {
    return (window.location.origin + '/supreme') as Url;
  }

  get phoneBusUrl(): Url | undefined {
    return window.phoneBusUrl ? window.phoneBusUrl : undefined;
  }

  get originDomain(): Url {
    return window.location.origin as Url;
  }

  get domain(): Host {
    return window.location.hostname.split('.').slice(-2).join('.') as Host;
  }

  addEntry<T>(key: StorageKey, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  clearEntry(key: StorageKey) {
    localStorage.removeItem(key);
  }

  getEntry(key: StorageKey): string | null {
    return localStorage.getItem(key);
  }
}

const appStorage = new AppStorage();

export { appStorage, AppStorage };
